import React from 'react';
import TimePickerProps from '../TimePicker/types';
import TimePicker from '../TimePicker';

const TimePickerMinutes: React.FC<TimePickerProps> = ({
  id,
  label,
  labelId,
  value,
  onFieldChange,
  ...props
}) => {
  const minutesOptions = [
    { id: '00', name: '00' },
    { id: '15', name: '15' },
    { id: '30', name: '30' },
    { id: '45', name: '45' },
  ];

  return (
    <TimePicker
      id={id}
      label={label}
      labelId={labelId}
      values={minutesOptions}
      value={value}
      onChange={(event) => onFieldChange?.(event)}
      {...props}
    />
  );
};

export default TimePickerMinutes;
